import { render, staticRenderFns } from "./PersonalDetailsKey.vue?vue&type=template&id=65df159c&"
import script from "./PersonalDetailsKey.vue?vue&type=script&lang=js&"
export * from "./PersonalDetailsKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65df159c')) {
      api.createRecord('65df159c', component.options)
    } else {
      api.reload('65df159c', component.options)
    }
    module.hot.accept("./PersonalDetailsKey.vue?vue&type=template&id=65df159c&", function () {
      api.rerender('65df159c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/PersonalDetailsKey.vue"
export default component.exports